// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/manage/downloadCenter',
    name: 'ManageDownloadCenter',
    component: layout,
    redirect: '/manage/downloadCenter/index',
    meta: {
      title: '下载中心',
      icon: 'i-menu:download',
      roles: [0]
    },
    sort: 7,
    children: [
      {
        path: 'index',
        name: 'ManageDownloadCenterIndex',
        component: () => import('@/views/Sentiment/DownloadCenter.vue'),
        meta: {
          title: '下载中心',
          icon: 'download',
          iconIsComponent: true,
          roles: [0]
        }
      }
    ]
  }
]
export default routes
